import { IconButton, Switch } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

// Define the column configuration here
export const finishListColumnsL = (handleEdit, handleChangeStatus) => [
  {
    field: "id",
    flex: 1,
    headerName: "It",
  },
  {
    field: "finishCode",
    headerName: "Finish Code",
    flex: 1,
    renderCell: (params) => (
      <FlexBox justifyContent="space-between">{params.value}</FlexBox>
    ),
  },
  { field: "finishDescription", headerName: "Description", flex: 1 },
  {
    field: "isApproved",
    headerName: "Is Approved",
    flex: 1,
    renderCell: (params) => (
      <Switch
        checked={params.row.isApproved}
        onChange={() => {
          handleChangeStatus(params.row.id, params.row.isApproved);
        }}
        inputProps={{ "aria-label": "controlled" }}
      />
    ),
  },
  {
    field: "edit",
    headerName: "Edit",
    flex: 1,
    renderCell: (params) => (
      <IconButton onClick={() => handleEdit(params.row)}>
        <EditIcon />
      </IconButton>
    ),
  },
];
